import React from "react";

interface TemperatureGaugeProps {
  ambient: number;
  current: number;
  operating: number;
  onClick?: () => void;
}

const TemperatureGauge: React.FC<TemperatureGaugeProps> = ({ ambient, current, operating, onClick }) => {
  // Gauge settings
  const min = -10;
  const max = 40;
  const percent = (v: number) => Math.max(0, Math.min(1, (v - min) / (max - min)));
  const currentAngle = percent(current) * 180 - 90;
  const thresholdAngle = percent(operating) * 180 - 90;

  return (
    <div
      style={{ width: 120, height: 80, position: 'relative', margin: '8px 0', cursor: onClick ? 'pointer' : undefined }}
      onClick={onClick}
    >
      <svg width="120" height="80" viewBox="0 0 120 80">
        <path d="M20,70 A50,50 0 0,1 100,70" fill="none" stroke="#eee" strokeWidth="12" />
        {/* Operating threshold */}
        <line x1="60" y1="70" x2={60 + 50 * Math.cos(thresholdAngle * Math.PI / 180)} y2={70 + 50 * Math.sin(thresholdAngle * Math.PI / 180)} stroke="#fbc02d" strokeWidth="4" />
        {/* Current temp pointer */}
        <line x1="60" y1="70" x2={60 + 40 * Math.cos(currentAngle * Math.PI / 180)} y2={70 + 40 * Math.sin(currentAngle * Math.PI / 180)} stroke="#e53935" strokeWidth="4" />
      </svg>
      <div style={{ position: 'absolute', left: 0, right: 0, top: 60, textAlign: 'center', fontSize: 13 }}>
        <span style={{ color: '#e53935' }}>Current: {current}°C</span>
      </div>
      <div style={{ position: 'absolute', left: 0, right: 0, top: 75, textAlign: 'center', fontSize: 12, color: '#2196f3' }}>
        Ambient: {ambient}°C
      </div>
    </div>
  );
};

export default TemperatureGauge;
